import React from 'react';
import { Modal, Box, Typography, Button, useMediaQuery } from '@mui/material';
import BottomSheetDialog from './popup/mobile/mobile-bottom-sheet';
import theme from '../util/theme/theme';

type Props = {
    open: boolean;
    onClose: () => void;
    title?: string;
    children: React.ReactNode;
};

const style = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    borderRadius: 2,
};

const ModalWrapper: React.FC<Props> = ({ open, onClose, title, children }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const content = (
        <>
            {title && <Typography variant="h6" mb={2}>{title}</Typography>}
            {children}
            <Box mt={3} display="flex" justifyContent="flex-end">
                <Button onClick={onClose} variant="outlined">Close</Button>
            </Box>
        </>
    );

    if (isMobile) {
        return (
            <BottomSheetDialog open={open} onClose={onClose} fitContent>
                <Box sx={{ p: 2 }}>{content}</Box>
            </BottomSheetDialog>
        );
    }

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={style}>{content}</Box>
        </Modal>
    );
};

export default ModalWrapper;
